import {VideoTileGameTitleDefaultBox} from "./video-tile-game-title-default.box";

export const VideoTileGameTitleBox = VideoTileGameTitleDefaultBox;
